import { OrderedMap } from 'immutable';
import pick from 'lodash.pick';

import {
  OWNER_PARAM_MAP,
  FILTER_KEYS,
} from '../../common/filters/constants';

export const FILTERS_INFO = Object.freeze({
  [FILTER_KEYS.OWNER]: Object.freeze({
    name: 'Owner',
    inputType: 'radio',
    search: true,
  }),
  [FILTER_KEYS.BUILD]: Object.freeze({
    name: 'Build',
    search: true,
  }),
  [FILTER_KEYS.OS]: Object.freeze({
    name: 'OS',
  }),
  [FILTER_KEYS.BROWSER]: Object.freeze({
    name: 'Browser',
  }),
  [FILTER_KEYS.TAG]: Object.freeze({
    name: 'Tag',
    search: true,
  }),
  [FILTER_KEYS.FRAMEWORK]: Object.freeze({
    name: 'Framework',
  }),
});

export const FILTERS_MAP = OrderedMap(pick(FILTERS_INFO, [
  FILTER_KEYS.OWNER,
  FILTER_KEYS.BUILD,
  FILTER_KEYS.OS,
  FILTER_KEYS.BROWSER,
  FILTER_KEYS.TAG,
  FILTER_KEYS.FRAMEWORK,
]));

export const COMMON_VDC_FILTERS_MAP = OrderedMap(pick(FILTERS_INFO, [
  FILTER_KEYS.OWNER,
  FILTER_KEYS.BUILD,
  FILTER_KEYS.OS,
  FILTER_KEYS.BROWSER,
  FILTER_KEYS.FRAMEWORK,
  FILTER_KEYS.TAG,
]));

export const COVERAGE_FILTERS_MAP = OrderedMap(pick(FILTERS_INFO, [
  FILTER_KEYS.OWNER,
]));

export { OWNER_PARAM_MAP };
